import 'primeicons/primeicons.css';
import { keyframes } from 'styled-components';

export const FlexAlignCenterJustifyBetween = `
  	display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const FlexAlignCenterJustifyCenter = `
  	display: flex;
    justify-content: center;
    align-items: center;
`;

export const fadeIn = keyframes`
  0% {
    opacity: 0;
    visibility: hidden;
  }
  100% {
    opacity: 1;
    visibility: visible;
  }
`;

export const fadeOut = keyframes`
  0% {
    opacity: 1;
    visibility: visible;
  }
  100% {
    opacity: 0;
    visibility: hidden;
  }
`;
